<template>
    <div v-if="exibir" class="confirmation-modal-overlay">
        <div class="confirmation-modal">
            <div class="modal-header">
                <h3 class="modal-title">{{ titulo }}</h3>
            </div>
            <div class="modal-body">
                <p>{{ mensagem }}</p>
            </div>
            <div class="modal-actions">
                <button class="btn btn-cancel" @click="cancelar">
                    Cancelar
                </button>
                <button 
                    class="btn btn-primary" 
                    @click="confirmar" 
                    :disabled="processando"
                >
                    <span v-if="processando" class="btn-loading"></span>
                    Confirmar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalConfirmacaoTermoDesentranhamento',
    props: {
        exibir: {
            type: Boolean,
            default: false
        },
        titulo: {
            type: String,
            default: 'Deseja finalizar o termo de desentranhamento?'
        },
        mensagem: {
            type: String,
            default: 'Após confirmação não será possível redigi-lo novamente, ficando disponível apenas para visualização.'
        },
        processando: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        cancelar() {
            this.$emit('cancelar')
        },
        confirmar() {
            this.$emit('confirmar')
        }
    }
}
</script>

<style scoped>
/* Confirmation Modal */
.confirmation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirmation-modal {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow: auto;
}

.modal-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
  color: #212121;
}

.modal-body {
  padding: 16px 24px;
}

.modal-body p {
  margin: 0;
  color: #616161;
  line-height: 1.5;
}

.modal-actions {
  padding: 8px 16px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* Buttons */
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  min-width: 64px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-cancel {
  background-color: transparent;
  color: #616161;
}

.btn-cancel:hover:not(:disabled) {
  background-color: rgba(97, 97, 97, 0.1);
}

.btn-primary {
  background-color: #0067A5;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #005a91;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-loading {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .confirmation-modal {
    margin: 16px;
    width: calc(100% - 32px);
  }
}
</style>